import * as mui from '@mui/material'
import React from 'react'
import { Field } from 'formik'
import { Select } from 'formik-mui'

import { langSwitchContext, Languages } from 'context/translations'
import { UserLanguages } from 'types/graphql/schema'


export function LanguageSelector() {
  const [lang, setLang] = React.useContext(langSwitchContext)

  return (
    <>
      <Field
        component={Select}
        error={false}
        onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
          setLang(e.target.value as UserLanguages)
        }}
        sx={{
          color: '#7F7F7F',
          '& .MuiSelect-select': {py: 1},
        }}
        value={lang}
      >
        {Object.entries(Languages).map(([key, label]) => (
          <mui.MenuItem key={key} value={key}>
            {label}
          </mui.MenuItem>
        ))}
      </Field>
    </>
  )
}